// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__A76g9","large":"Avatar_large__x05CQ","small":"Avatar_small__iA6tV"};